import { TemplateHome } from "@lumora/ui";
import { Sections } from "../layout.js";
import type { LayoutName } from "../variant.js";

export function Home({ layout }: { layout: LayoutName }) {
  return (
    <TemplateHome>
      <Sections layout={layout} />
    </TemplateHome>
  );
}
